import React, { useRef } from 'react';
import PricingTabsSection from '../components/landingPage/PricingPage/PricingTabsSection';
import { useReveal, useCountUp } from '../components/landingPage/common/landingHooks';

const PricingPlans = () => {
    const rootRef = useRef(null);
    useReveal(rootRef);
    useCountUp(rootRef);

    return (
        <div className="lp-page" ref={rootRef}>
            <PricingTabsSection />
        </div>
    );
};

export default PricingPlans;
